import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["holding-up-late-in-a-run"]!;

export function Body() {
  return (
    <>
      <p>
        A fitness test is usually done when you are rested. A marathon is not. After two or
        three hours of running, the body that crosses the line is not the one that started.
        Two recent reviews argue that how well you hold up over time deserves as much attention
        as how fit you are when fresh.
      </p>

      <h2>What the researchers did</h2>
      <p>
        In 2021, a group of researchers from New Zealand and Norway, including Stephen Seiler,
        reviewed how endurance athletes are usually tested. Their point was simple: the numbers
        measured in a rested athlete change during long exercise, and most testing ignores
        that. They called the ability to resist those changes durability.
      </p>
      <p>
        In 2024, Andrew Jones from the University of Exeter went a step further. Endurance
        performance is usually explained by three things: your maximal oxygen uptake, how
        economically you move, and how large a share of your maximum you can sustain. He argued
        that how well these hold up during long exercise should be counted as a fourth factor.
      </p>

      <h2>What they found</h2>
      <p>
        Jones describes how critical power, roughly the highest effort you can sustain without
        fatigue running away from you, fell by about 10 percent on average after two hours of
        hard cycling. The striking part was the spread. Some people lost less than 1 percent,
        others around 32 percent. Why some hold up so much better than others is not yet known.
      </p>

      <h2>What it means for you</h2>
      <p>
        The pace you can hold for 30 minutes when fresh is not the pace you can hold at 35 km in
        a marathon. Long runs are where you learn how your body copes late in a run, and where
        it gets used to it.
      </p>
      <p>
        Start long runs and races at a pace you can sustain, eat and drink on longer runs, and
        notice how you feel and how your heart rate behaves in the final part. Our article on
        marathon pacing shows what an ambitious first half can cost later.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        Both papers are reviews, and much of the data comes from cycling. They show that
        durability varies a lot between people, but not yet which training improves it best.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training follows how your heart rate develops relative to your pace on long, steady
        runs. Over a season you can see whether you hold up better late in your long runs.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Maunder et al. (2021), The importance of 'durability' in the physiological profiling of
          endurance athletes.{" "}
          <a href="https://doi.org/10.1007/s40279-021-01459-0">Sports Medicine</a>.
        </li>
        <li>
          Jones (2024), The fourth dimension: physiological resilience as an independent
          determinant of endurance exercise performance.{" "}
          <a href="https://doi.org/10.1113/JP284205">Journal of Physiology</a>.
        </li>
      </ul>
    </>
  );
}
